import React from "react";
import { IonCard, IonItem, IonImg } from "@ionic/react";
import "./appcards.styles.css";

interface IAppCardsProps {
  image?: any;
  size?: "small" | "regular" | "medium";
  title: string;
  description?: string;
  onClick?: any;
  badge?: number | undefined;
}

const AppCards = ({
  image,
  size,
  title,
  description,
  onClick,
  badge,
}: IAppCardsProps) => {
  return (
    <div className="app-with-badges">
      <IonCard className={`app-cards app-cards-${size}`} onClick={onClick}>
        <IonItem className={`app-cards-item app-cards-item-${size}`}>
          <IonImg
            src={image}
            alt={title}
            className={`app-cards-image-${size} app-cards-image`}
          />
        </IonItem>
        <h1 className="title-text">{title}</h1>

        {description && <h6 className="description-text">{description}</h6>}
      </IonCard>
      {badge ? <span className="card-badges">{badge}</span> : <></>}
    </div>
  );
};

AppCards.defaultProps = {
  size: "regular",
  badge: undefined,
};

export default AppCards;
